import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase';
const config = {
	apiKey: 'AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ',
	authDomain: 'distributed-eye-251310.firebaseapp.com',
};
if (!firebase.apps.length) {
firebase.initializeApp(config);
}
     const uiConfig = {
        signInFlow: 'popup',
        signInOptions: [
          firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        ],
        callbacks: {
	signInSuccessWithAuthResult: function(authResult, redirectUrl) {
	var phone_no = authResult['user']['phoneNumber'];
	//console.log(phone_no);
			const cookies = new Cookies();
			var hosturl = window.location.href;
			//var hosturl = window.location.protocol +"//" + window.location.hostname + "/web";
			var api_url = localStorage.getItem('api_url');

			var signin = new FormData();
			signin.set('phone', phone_no);
			signin.set('fcmtoken', cookies.get('mytoken'));
			axios({
				method: 'post',
				url: api_url+'webcheckphone',
				data: signin,
				config: { headers: {'Content-Type': 'multipart/form-data' }}
							})
			.then(res => {
				if(res.data.status !== "false"){
//					cookies.set('editmobileno', phone_no);
				 var editprofile = new FormData();
				editprofile.set('phone', phone_no);
				editprofile.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
				    axios({
					method: 'post',
					url: api_url+'websetprofile',
					data: editprofile,
					config: { headers: {'Content-Type': 'multipart/form-data' }}
						    })
				.then(res => {
					alert('Successfully updated');
						hosturl = hosturl.replace('Editphonefirebase','');
		                window.location.href = hosturl+"EditProfile";
				    })
				}else{
					alert('Sorry, You are already registered this Mobile Number');
					hosturl = hosturl.replace('Editphonefirebase','');
					window.location.href = hosturl+"EditProfile";
				}
				
			})


	}	
        }
      };
   
   
   
class Editphonefirebase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            api_url:localStorage.getItem('api_url'),
        };
      }

     
    
 
    componentDidMount(){

    }
  
  
    render() {
        return (

            <div className="welcomePage">
        

                <div className="welcomePageCenterContent">

                    <div className="welcomeLogo"></div>

                   

<div className="w-100">
 <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
</div>



                </div>




            </div>

        );
    }

}




export default Editphonefirebase;
